import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNetDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 59,
	viewBox: "0 0 58 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_109807_185)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M53 5.2639H5V53.2639H53V5.2639Z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23.1604 36.0278H26.0439V19.722H23.5042V30.2286C23.5042 31.2597 23.5413 31.9912 23.6151 32.4232H23.5708C23.4821 32.2414 23.2825 31.9079 22.9719 31.4226L15.6302 19.722H12.5582V36.0278H15.109V25.3392C15.109 24.1946 15.0794 23.4479 15.0203 23.0992H15.0868C15.2125 23.4251 15.3715 23.7398 15.5637 24.043L23.1604 36.0278ZM7.17966 35.8345C7.49019 36.1302 7.86725 36.278 8.31085 36.278C8.76185 36.278 9.14261 36.1302 9.45314 35.8345C9.77106 35.5313 9.93002 35.1712 9.93002 34.7544C9.93002 34.3298 9.77106 33.966 9.45314 33.6628C9.14261 33.3595 8.76185 33.2079 8.31085 33.2079C7.86725 33.2079 7.49019 33.3595 7.17966 33.6628C6.86913 33.966 6.71387 34.3298 6.71387 34.7544C6.71387 35.1712 6.86913 35.5313 7.17966 35.8345ZM38.4656 36.0278H29.538V19.722H38.1107V22.019H32.1776V26.6355H37.645V28.921H32.1776V33.7423H38.4656V36.0278ZM46.5846 22.019H51.1537V19.722H39.387V22.019H43.945V36.0278H46.5846V22.019Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_109807_185",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 48,
				fill: "white",
				transform: "translate(5 5.2639)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgNetDark);
export { ForwardRef as ReactComponent };
